export const subStepsIds = Object.freeze({
    ParticipantType: "ParticipantType",
    BowlerMembership: "BowlerMembership",
    MembershipSearch: "MembershipSearch",
    MembershipCostAck: "MembershipCostAck",
    ViewBowlerInfo: "ViewBowlerInfo",
    EditBowlerInfo: "EditBowlerInfo",
    Consent: "Consent",
    ReviewAndPay: "ReviewAndPay",
    Finished: "Finished"
});

export const mainStepsIds = Object.freeze({
    Start: "Start",
    Membership: "Membership",
    Bowler: "Bowler",
    Consent: "Consent",
    ReviewAndPay: "ReviewAndPay",
    Finished: "Finished"
});